module.exports = __webpack_public_path__ + "static/media/Scarf_Rocker_01.b06f05a4.png";